
import style from '../CSS/FinalResult.module.css';
import icon from '../img/rankIcon.png';

const FinalResultItem = ({info}) => {
    return (
        <>
            <div style={{padding: '18px'}}>
                <div className={style.position}>
                    <img src={icon} alt=""/>
                    <span>{info.position}</span>
                </div>
                <div className={style.userInfo}>
                    <img src={info.userImage} alt=""/>
                    <div>
                        <h6>{info.name}</h6>
                        <span>Total Marks: {info.mark}</span>
                        <p>Superstar comments: {info.comment}</p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FinalResultItem;